import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import DriverFilter from "../DriverFilter/DriverFilter";
import DriverBody from "../DriverBody/DriverBody";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewDriver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      searchBy: {
        fullName: "",
      },
      column: [
        { name: "S.N" },
        { name: "Full Name" },
        { name: "Mobile Number" },
        { name: "Alternate Number" },
        { name: "Address" },
        { name: "Category" },
        { name: "Actions" },
      ],
      drivers: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getDrivers();
  }

  getDrivers = async () => {
    try {
      const response = await Axios.get(`${url}/api/drivers`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.drivers.length !== 0) {
        this.setState({ drivers: response.data.drivers, isEmpty: false });
      } else {
        this.setState({ drivers: [], isEmpty: true });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getDrivers();
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;

    const filtered = this.state.drivers.filter((driver) => {
      return (
        driver.driverFullName
          .toLowerCase()
          .indexOf(this.state.searchBy.fullName.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Driver List"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/driver/add"}
            urlTitle="Add Driver name"
          />
          {this.state.drivers.length !== 0 && (
            <DriverFilter
              data={this.state.searchBy}
              handleSearch={this.handleSearch}
            />
          )}

          {this.state.drivers.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {filtered
                    .slice(rowsPerPage * page, rowsPerPage * page + rowsPerPage)
                    .map((driver, index) => (
                      <DriverBody
                        data={driver}
                        key={index}
                        index={index}
                        getDrivers={this.getDrivers}
                      />
                    ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewDriver)));
